module.exports = __webpack_public_path__ + "img/investment.4d422164.png";